import React from "react";
import SectionCard from "./SectionCard";
import { Input, PhotoInput } from "./Fields";

export default function IdentitySection({ form, onChange, onOpenLibrary }) {
  return (
    <SectionCard
      title="Identité"
      description="Informations principales affichées sur le site."
    >
      <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
        <Input
          label="Nom de la mairie"
          name="nom_mairie"
          value={form.nom_mairie}
          onChange={onChange}
          placeholder="Ex : Mairie de Bruges"
        />

        <PhotoInput
          label="Logo de la mairie"
          name="logo_mairie"
          value={form.logo_mairie}
          onChange={onChange}
          onOpenLibrary={() => onOpenLibrary("logo_mairie")}
          previewMode="contain"
          hint="Le logo est affiché dans le header et parfois dans le footer."
        />

        <Input
          label="Adresse"
          name="adresse"
          value={form.adresse}
          onChange={onChange}
          placeholder="Ex : 87 avenue Charles de Gaulle"
        />

        <Input
          label="Code postal"
          name="code_postal"
          value={form.code_postal}
          onChange={onChange}
          placeholder="Ex : 33520"
        />

        <Input
          label="Ville"
          name="ville"
          value={form.ville}
          onChange={onChange}
          placeholder="Ex : Bruges"
        />

        <Input
          label="Site web officiel"
          name="site_web"
          value={form.site_web}
          onChange={onChange}
          placeholder="https://..."
        />
      </div>
    </SectionCard>
  );
}